import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'
import 'moment/locale/id'
import en from './locales/en.json'
import id from './locales/id.json'

export const LOCALE_STORAGE_KEY = 'customer.locale'
export type AppLocale = 'en' | 'id'

const resources = {
  en: {
    common: en.common,
    booking: en.booking,
    rent: en.rent,
    home: en.home,
    auth: en.auth,
    confirmation: en.confirmation,
  },
  id: {
    common: id.common,
    booking: id.booking,
    rent: id.rent,
    home: id.home,
    auth: id.auth,
    confirmation: id.confirmation,
  },
}

export function readStoredLocale(): AppLocale | null {
  const raw = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (raw === 'en' || raw === 'id') return raw
  return null
}

export function localeFromCountry(country?: string | null): AppLocale {
  const c = (country ?? '').toLowerCase()
  if (c.includes('indonesia') || c === 'id') return 'id'
  return 'en'
}

export function resolveInitialLocale(country?: string | null): AppLocale {
  return readStoredLocale() ?? localeFromCountry(country)
}

export function persistLocale(locale: AppLocale) {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
}

export function syncMomentLocale(locale: AppLocale) {
  moment.locale(locale === 'id' ? 'id' : 'en')
}

export async function changeAppLanguage(locale: AppLocale) {
  persistLocale(locale)
  syncMomentLocale(locale)
  await i18n.changeLanguage(locale)
}

if (!i18n.isInitialized) {
  const initial = resolveInitialLocale()
  syncMomentLocale(initial)
  i18n.use(initReactI18next).init({
    resources,
    lng: initial,
    fallbackLng: 'en',
    supportedLngs: ['en', 'id'],
    ns: ['common', 'booking', 'rent', 'home', 'auth', 'confirmation'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })
}

export default i18n
